import { FormattedMessage } from 'react-intl';
import React from 'react';

const idPrefix = 'LoginIndex';

const FormattedMessages = {
  emailText: (
    <FormattedMessage
      id={`${idPrefix}.EmailLabel`}
      defaultMessage="Email"
    ></FormattedMessage>
  ),
  passwordText: (
    <FormattedMessage
      id={`${idPrefix}.PasswordLabel`}
      defaultMessage="Password"
    ></FormattedMessage>
  ),
  loginText: (
    <FormattedMessage
      id={`${idPrefix}.LoginButton`}
      defaultMessage="Login"
    ></FormattedMessage>
  ),
  loginLoadingText: (
    <FormattedMessage
      id={`${idPrefix}.LoginLoadingText`}
      defaultMessage="Logging in..."
    ></FormattedMessage>
  ),
  signUpText: (
    <FormattedMessage
      id={`${idPrefix}.SignupText`}
      defaultMessage={"Don't have an account? "}
    ></FormattedMessage>
  ),
  registerText: (
    <FormattedMessage
      id={`${idPrefix}.RegisterLink`}
      defaultMessage="Register here!"
    ></FormattedMessage>
  ),
  forgotPassword: (
    <FormattedMessage
      id={`${idPrefix}.forgetPasswordLink`}
      defaultMessage="Forgot Password?"
    ></FormattedMessage>
  ),

  mfaVerificationTitle: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationTitle`}
      defaultMessage="Multi-Factor Authentication"
    ></FormattedMessage>
  ),
  mfaVerificationSms: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationSms`}
      defaultMessage="Please enter the code sent to you via SMS"
    ></FormattedMessage>
  ),
  mfaVerificationEmail: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationEmail`}
      defaultMessage="Please enter the code sent to you via Email"
    ></FormattedMessage>
  ),
  mfaVerificationSoftwareToken: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationSoftwareToken`}
      defaultMessage="Please enter the code from your authenticator application"
    ></FormattedMessage>
  ),
  mfaVerificationVerify: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationVerify`}
      defaultMessage="Verify"
    ></FormattedMessage>
  ),
  mfaVerificationVerifyLoading: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationVerifyLoading`}
      defaultMessage="Verifying..."
    ></FormattedMessage>
  ),
  mfaVerificationError: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationError`}
      defaultMessage="Invalid verification code"
    ></FormattedMessage>
  ),
  mfaVerificationRememberDevice: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationRememberDevice`}
      defaultMessage="Remember this device"
    ></FormattedMessage>
  ),
  mfaVerificationRememberDeviceTooltip: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationRememberDeviceTooltip`}
      defaultMessage="Do not require Multi-Factor Authentication for 30 days on this device"
    ></FormattedMessage>
  ),
  mfaVerificationCodeSent: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationCodeSent`}
      defaultMessage="Code sent"
    ></FormattedMessage>
  ),
  mfaVerificationResendCode: (
    <FormattedMessage
      id={`${idPrefix}.mfaVerificationResendCode`}
      defaultMessage="Resend code"
    ></FormattedMessage>
  ),
};

export default FormattedMessages;
